var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleSmallLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 12.7101C10.5062 12.6171 10.4318 12.5065 10.381 12.3846C10.3302 12.2628 10.3041 12.1321 10.3041 12.0001C10.3041 11.868 10.3302 11.7373 10.381 11.6155C10.4318 11.4936 10.5062 11.383 10.5999 11.2901L15.1899 6.71006C15.2836 6.6171 15.358 6.5065 15.4088 6.38464C15.4596 6.26278 15.4857 6.13207 15.4857 6.00006C15.4857 5.86805 15.4596 5.73734 15.4088 5.61548C15.358 5.49362 15.2836 5.38302 15.1899 5.29006C15.0025 5.10381 14.7491 4.99927 14.4849 4.99927C14.2207 4.99927 13.9673 5.10381 13.7799 5.29006L9.18989 9.88006C8.62809 10.4426 8.31253 11.2051 8.31253 12.0001C8.31253 12.7951 8.62809 13.5576 9.18989 14.1201L13.7799 18.7101C13.9662 18.8948 14.2176 18.999 14.4799 19.0001C14.6115 19.0008 14.742 18.9756 14.8638 18.9258C14.9856 18.8761 15.0965 18.8027 15.1899 18.7101C15.2836 18.6171 15.358 18.5065 15.4088 18.3846C15.4596 18.2628 15.4857 18.1321 15.4857 18.0001C15.4857 17.868 15.4596 17.7373 15.4088 17.6155C15.358 17.4936 15.2836 17.383 15.1899 17.2901L10.5999 12.7101Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleSmallLeft);
export default __webpack_public_path__ + "static/media/angle-small-left.cb791e84a79b8ab6a4ae8c90bccf3991.svg";
export { ForwardRef as ReactComponent };